import { useEffect, useState } from "react";
import { HeartHandshake, Coins, Scale, Building2, Clock, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { StatCard } from "./StatCard";
import { PeriodFilter, periodParams } from "./PeriodFilter";

const ICONS = { infaq: HeartHandshake, sedekah: Coins, zakat: Scale, pembangunan: Building2 };

export const DonationRecap = ({ version }) => {
  const now = new Date();
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [year, setYear] = useState(String(now.getFullYear()));
  const [recap, setRecap] = useState(null);

  useEffect(() => {
    api.get(`/donations/recap?${periodParams(month, year)}`).then((r) => setRecap(r.data)).catch(() => {});
  }, [month, year, version]);

  return (
    <div className="space-y-6" data-testid="donation-recap">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <PeriodFilter month={month} year={year} setMonth={setMonth} setYear={setYear} prefix="recap" />
        <div className="rounded-full bg-[#f6ebd0] text-[#8a6d14] px-5 py-2 text-sm font-semibold" data-testid="recap-total">
          Total Terkonfirmasi: {rupiah(recap?.total)}
        </div>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {(recap?.per_type || []).map((t) => (
          <StatCard key={t.type} label={`${t.label} · ${t.count} donasi`} value={rupiah(t.total)} icon={ICONS[t.type]} testId={`recap-${t.type}`} />
        ))}
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <StatCard label="Menunggu Konfirmasi" value={recap?.per_status?.menunggu ?? 0} icon={Clock} tone="bg-[#f6ebd0] text-[#8a6d14]" testId="recap-menunggu" />
        <StatCard label="Dikonfirmasi" value={recap?.per_status?.dikonfirmasi ?? 0} icon={CheckCircle2} testId="recap-dikonfirmasi" />
        <StatCard label="Ditolak" value={recap?.per_status?.ditolak ?? 0} icon={XCircle} tone="bg-red-50 text-red-700" testId="recap-ditolak" />
      </div>
    </div>
  );
};
